/* src/app/support/sim-list/sim-list.component.css */
/*# sourceMappingURL=sim-list.component.css.map */
